export const subscriptionConstants = {
    GETALL_REQUEST: 'SUBSCRIPTION_GETALL_REQUEST',
    GETALL_SUCCESS: 'SUBSCRIPTION_GETALL_SUCCESS',
    GETALL_FAILURE: 'SUBSCRIPTION_GETALL_FAILURE',

    DELETE_REQUEST: 'SUBSCRIPTION_DELETE_REQUEST',
    DELETE_SUCCESS: 'SUBSCRIPTION_DELETE_SUCCESS',
    DELETE_FAILURE: 'SUBSCRIPTION_DELETE_FAILURE'
};
